import NewLogin from './newLogin';
import AuthButton from '../../AuthButton'

const Login = () => {
  
  return (
    <div>
     <AuthButton />
      {/* <NewLogin /> */}
    </div>
  )
 }
export default Login